import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Form, FormGroup, Label, Input } from "reactstrap";
import LottieLoader from "../LottieLoader";
import lottieLoaderFile from "../../files/animation/loading.json";
import lottieEmptyFile from "../../files/animation/empty_new.json";

const DEFAULT_FIELDS = {
  criticalValue: "",
  persistentElevation: ""
};

function EscalationPlan({ careProviderId, staffId }) {
  const dispatch = useDispatch();

  const plan = useSelector((state) =>
    staffId
      ? state.careprovider.escalationPlansStaff
      : careProviderId
      ? state.careprovider.escalationPlansAdmin
      : state.careprovider.escalationPlans
  );
  const ongoingRequest = useSelector((state) =>
    staffId
      ? state.careprovider.ongoingEscalationPlanStaffRequest
      : careProviderId
      ? state.careprovider.ongoingEscalationPlanAdminRequest
      : state.careprovider.ongoingEscalationPlanRequest
  );

  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState(DEFAULT_FIELDS);

  const startEdit = () => {
    setForm({
      criticalValue: plan ? plan.criticalValue || "" : "",
      persistentElevation: plan ? plan.persistentElevation || "" : ""
    });
    setEditing(true);
  };

  const cancelEdit = () => setEditing(false);

  useEffect(() => {
    if (staffId) {
      dispatch({ type: "DO_GET_ESCALATION_PLANS_STAFF", payload: { staffId } });
    } else if (careProviderId) {
      dispatch({ type: "DO_GET_ESCALATION_PLANS_ADMIN", payload: { careProviderId } });
    } else {
      dispatch({ type: "DO_GET_ESCALATION_PLANS" });
    }
  }, [careProviderId, staffId]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (staffId) {
      dispatch({
        type: "DO_SAVE_ESCALATION_PLAN_STAFF",
        payload: { ...form, staffId }
      });
    } else if (careProviderId) {
      dispatch({
        type: "DO_SAVE_ESCALATION_PLAN_ADMIN",
        payload: { ...form, careProviderId }
      });
    } else {
      dispatch({
        type: "DO_SAVE_ESCALATION_PLAN",
        payload: { ...form }
      });
    }
    setEditing(false);
  };

  return (
    <div className="col-12 mx-auto mt-4">
      <div className="header-device-list" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <h3 className="title-device mb-0">
          <i className="mdi mdi-alert-circle-outline mr-1"></i> Escalation Plan
        </h3>
        {!editing && (
          <button type="button" className="btn btn-info print-click-cls" style={{ margin: 0 }} onClick={startEdit}>
            {plan ? (
              <><i className="mdi mdi-pencil" style={{ fontSize: 17 }}></i> Edit Plan</>
            ) : (
              <><i className="mdi mdi-plus" style={{ fontSize: 17 }}></i> Add Plan</>
            )}
          </button>
        )}
      </div>

      {ongoingRequest && (
        <LottieLoader
          loadLoop={true}
          autoplayLoop={true}
          source={lottieLoaderFile}
          Lheight={150}
          Lwidth={150}
          subTitle="Please Wait ..."
        />
      )}

      {!ongoingRequest && !plan && !editing && (
        <LottieLoader
          loadLoop={false}
          autoplayLoop={true}
          source={lottieEmptyFile}
          Lheight={200}
          Lwidth={200}
          titleSmall="No Escalation Plan found :("
          subTitleSmall="Click 'Add Plan' to create one."
        />
      )}

      {!ongoingRequest && !editing && plan && (
        <div style={{ backgroundColor: "white", padding: "20px", borderRadius: 6, marginTop: 8 }}>
          <FormGroup>
            <Label className="font-weight-bold">Critical Value</Label>
            <Input
              type="text"
              className="input-date-filter remove-bottom-margin"
              value={plan.criticalValue || ""}
              disabled
            />
          </FormGroup>
          <FormGroup>
            <Label className="font-weight-bold">Persistent Elevation &gt; 3 Days</Label>
            <Input
              type="text"
              className="input-date-filter remove-bottom-margin"
              value={plan.persistentElevation || ""}
              disabled
            />
          </FormGroup>
        </div>
      )}

      {!ongoingRequest && editing && (
        <Form onSubmit={handleSubmit}>
          <div style={{ backgroundColor: "white", padding: "20px", borderRadius: 6, marginTop: 8 }}>
            <FormGroup>
              <Label><strong>Critical Value</strong> <span className="text-muted">(Same-day phone call)</span></Label>
              <Input
                type="text"
                name="criticalValue"
                className="input-date-filter remove-bottom-margin"
                value={form.criticalValue}
                onChange={handleChange}
                placeholder="e.g., Same-day phone call"
                required
              />
            </FormGroup>
            <FormGroup>
              <Label><strong>Persistent Elevation &gt; 3 Days</strong> <span className="text-muted">(Provider notified)</span></Label>
              <Input
                type="text"
                name="persistentElevation"
                className="input-date-filter remove-bottom-margin"
                value={form.persistentElevation}
                onChange={handleChange}
                placeholder="e.g., Provider notified"
                required
              />
            </FormGroup>
            <div style={{ display: "flex", justifyContent: "center", gap: "12px", marginTop: 12 }}>
              <button
                type="submit"
                style={{ background: "#4CAF50", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 18px", display: "flex", alignItems: "center", cursor: "pointer", fontSize: "14px" }}
              >
                <i className="mdi mdi-check-circle" style={{ fontSize: 20, marginRight: 8 }}></i>
                {plan ? "Update Plan" : "Save Plan"}
              </button>
              <button
                type="button"
                onClick={cancelEdit}
                style={{ background: "#f44336", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 18px", display: "flex", alignItems: "center", cursor: "pointer", fontSize: "14px" }}
              >
                <i className="mdi mdi-close-circle" style={{ fontSize: 20, marginRight: 8 }}></i>Cancel
              </button>
            </div>
          </div>
        </Form>
      )}
    </div>
  );
}

export default EscalationPlan;